// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.time-selector[data-v-d4baa210] {\n  display: flex;\n  align-items: center;\n}\n.separator[data-v-d4baa210] {\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
